
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface PropertyMaintenanceDetailsProps {
  roofAge: string;
  setRoofAge: (value: string) => void;
  windowType: string;
  setWindowType: (value: string) => void;
  furnaceAge: string;
  setFurnaceAge: (value: string) => void;
  waterHeaterAge: string;
  setWaterHeaterAge: (value: string) => void;
}

export const PropertyMaintenanceDetailsSection = ({
  roofAge,
  setRoofAge,
  windowType,
  setWindowType,
  furnaceAge,
  setFurnaceAge,
  waterHeaterAge,
  setWaterHeaterAge,
}: PropertyMaintenanceDetailsProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="roofAge">Age of Roof</Label>
        <Select value={roofAge} onValueChange={setRoofAge}>
          <SelectTrigger id="roofAge" className="bg-muted">
            <SelectValue placeholder="Select age" />
          </SelectTrigger>
          <SelectContent className="bg-background z-50">
            <SelectItem value="Under 1 year">Under 1 year</SelectItem>
            <SelectItem value="1-3 years">1-3 years</SelectItem>
            <SelectItem value="3-6 years">3-6 years</SelectItem>
            <SelectItem value="6-9 years">6-9 years</SelectItem>
            <SelectItem value="10-15 years">10-15 years</SelectItem>
            <SelectItem value="15-20 years">15-20 years</SelectItem>
            <SelectItem value="20+ years">20+ years</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="windowType">Window Type</Label>
        <Select value={windowType} onValueChange={setWindowType}>
          <SelectTrigger className="bg-muted">
            <SelectValue placeholder="Select window type" />
          </SelectTrigger>
          <SelectContent className="bg-background z-50">
            <SelectItem value="Wood">Wood</SelectItem>
            <SelectItem value="Aluminum">Aluminum</SelectItem>
            <SelectItem value="Vinyl">Vinyl</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="furnaceAge">Age of Furnace/Boiler</Label>
        <Select value={furnaceAge} onValueChange={setFurnaceAge}>
          <SelectTrigger id="furnaceAge" className="bg-muted">
            <SelectValue placeholder="Select age" />
          </SelectTrigger>
          <SelectContent className="bg-background z-50">
            <SelectItem value="Under 1 year">Under 1 year</SelectItem>
            <SelectItem value="1-3 years">1-3 years</SelectItem>
            <SelectItem value="3-6 years">3-6 years</SelectItem>
            <SelectItem value="6-9 years">6-9 years</SelectItem>
            <SelectItem value="10-15 years">10-15 years</SelectItem>
            <SelectItem value="15-20 years">15-20 years</SelectItem>
            <SelectItem value="20+ years">20+ years</SelectItem>
          </SelectContent>
        </Select>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="waterHeaterAge">Age of Hot Water Tank</Label>
        <Select value={waterHeaterAge} onValueChange={setWaterHeaterAge}>
          <SelectTrigger id="waterHeaterAge" className="bg-muted">
            <SelectValue placeholder="Select age" />
          </SelectTrigger>
          <SelectContent className="bg-background z-50">
            <SelectItem value="Under 1 year">Under 1 year</SelectItem>
            <SelectItem value="1-3 years">1-3 years</SelectItem>
            <SelectItem value="3-6 years">3-6 years</SelectItem>
            <SelectItem value="6-9 years">6-9 years</SelectItem>
            <SelectItem value="10-15 years">10-15 years</SelectItem>
            <SelectItem value="15-20 years">15-20 years</SelectItem>
            <SelectItem value="20+ years">20+ years</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};
